import React from 'react'

export const Aportaciones = () => {
  return (
    <div>Aportaciones</div>
  )
}
